<script setup lang="ts">
import { RouterWrapper } from '@bagelink/vue'
</script>

<template>
	<ModalContainer />
	<div>
		<RouterWrapper class="relative" />
	</div>
</template>
